import type { ComponentProps } from 'react';

import type { SocialSharing } from '@change/ds-core-ui';
import {
	EmailOutlineIcon,
	FacebookIcon,
	FacebookMessengerIcon,
	InstagramIcon,
	LineIcon,
	LinkIcon,
	NextDoorIcon,
	RedditIcon,
	ShareIcon,
	TikTokIcon,
	TwitterIcon,
	VkIcon,
	WhatsAppIcon,
} from '@change/ds-icons';

import type { RoundShareIconButtonChannel } from './types';

type SocialSharingConfig = {
	icon: React.ReactElement;
	variant: ComponentProps<typeof SocialSharing>['variant'];
};

export const SOCIAL_SHARING_ICON_CONFIG_BY_CHANNEL: Readonly<
	Record<Exclude<RoundShareIconButtonChannel, 'sms'>, SocialSharingConfig>
> = {
	facebook: { icon: <FacebookIcon />, variant: 'facebook' },
	facebookMessenger: { icon: <FacebookMessengerIcon />, variant: 'facebookMessenger' },
	twitter: { icon: <TwitterIcon />, variant: 'twitter' },
	whatsapp: { icon: <WhatsAppIcon />, variant: 'whatsapp' },
	instagram: { icon: <InstagramIcon />, variant: 'instagram' },
	instagramStories: { icon: <InstagramIcon />, variant: 'instagram' },
	nextdoor: { icon: <NextDoorIcon />, variant: 'nextdoor' },
	reddit: { icon: <RedditIcon />, variant: 'reddit' },
	tiktok: { icon: <TikTokIcon />, variant: 'tiktok' },
	vk: { icon: <VkIcon />, variant: 'default' },
	line: { icon: <LineIcon />, variant: 'default' },
	email: { icon: <EmailOutlineIcon />, variant: 'default' },
	copy: { icon: <LinkIcon />, variant: 'default' },
	mobileNativeShare: { icon: <ShareIcon />, variant: 'default' },
};
